
import "./Parameters.scss";
import { ClientOnly } from "./ClientOnly";
import { Link } from "./Link";
import { PopupContext, usePopup } from "./PopupProvider";
import { useContext } from "react";

function Parameters(props) {
  const {
    zoomColor,
    title,
    description,
    image,
    images,
    link,
    logo,
    linkR,
    openPopup,
    popupHeight,
    descriptionPlugin,
  } = props;
  const { openImagePopup } = useContext(PopupContext)
  const settings = {
    dots: true,
  };
  const renderImage = (src, i) => {
    if (src?.jpg || src?.png) {

      return <picture
        style={{

        }}
        className="parameters__image">
        <source

          srcSet={src.avif}
          type="image/avif" />
        <img
          loading={i !== 0 ? 'lazy' : 'eager'}
          src={src?.jpg || src?.png}
          style={{ width: '100%' }}
          alt="слайды презентаций"
          key={i}
        />
      </picture>
    }
    return (
      <img
        src={src}
        alt="слайды презентаций"
        key={i}
        className="parameters__image"
      />

    )
  }
  const renderFallbackSlider = () => {
    if (!images?.length) {
      return <></>
    }
    return renderImage(images[0], 0)
  }
  return (
    <>
      {logo ? (
        <div className="row w-100 mb-4 align-items-center">
          <h1 className="w-70 text-center col">{title}</h1>
          <Link
            to="https://reestr.digital.gov.ru/reestr/1578353/"
            target="_blank"
            rel="noopener noreferrer"
            className="col parameters__logo link"
          >
            <img src={logo} className="parameters__logo-img" alt="логотип Минкомсвязи" />
            <p className="parameters__logo-p">Внесено в реестр Минкомсвязи</p>
          </Link>
        </div>
      ) : (
        title ? <h1 className="mb-5 w-70 text-center">{title}</h1> : <></>
      )}
      <div className="mb-5  mt-3">
        <div style={{ float: 'right' }} className=" p-0">
          <div
            style={{ maxWidth: "650px", marginBottom: "20px" }}
            className="parameters__image-container"
          >
            <img
              className="col"
              alt="главная страница сайта "
              src={image}
              style={{ width: "100%" }}
            />
            <button
              className="parameters__zoom-button link"
              onClick={() => {

                openImagePopup(
                  popupHeight === true
                    ? { image: image, height: "90%" }
                    : { image: image }
                )
              }
              }
            >
              <Zoom style={{ width: '100%' }} zoomColor={zoomColor ? zoomColor : 'black'} />
            </button>
          </div>

          {link && (
            <a
              href={link.link}
              rel="noopener noreferrer"
              target="_blank"
              className="link"
              style={{ color: "var(--red)" }}
            >
              {link.text}
            </a>
          )}
          {linkR && (
            <a
              href={linkR.link}
              rel="noopener noreferrer"
              target="_blank"
              className="link"
              style={{ color: "var(--blue)" }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <img
                  src={linkR.img}
                  alt="ссылка на сайт"
                  style={{ width: "8%", marginRight: "10px" }}
                />
                <h5 className="m-0">{linkR.text}</h5>
              </div>
            </a>
          )}
        </div>
        {description ? (
          <div className=" d-flex align-items-center justify-content-center">
            description
          </div>
        ) : (
          <div className=" p-0">{props.children}</div>
        )}

      </div>
      {images && (
        <div className="d-flex justify-content-center">
          <div style={{ maxWidth: '80vw' }} className="mb-5 parameters__container  ">
            <ClientOnly
              fallback={renderFallbackSlider}
              props={settings}
              component={() => import("react-slick")}
            >
              {images.map(renderImage)}
            </ClientOnly>

          </div>
        </div>

      )}
      {descriptionPlugin && descriptionPlugin}
      <div className="w-100 d-flex flex-column align-items-center">
        <Link to={'/'}>
          <button
            className="accent-button button-hover mt-4"
            type="button"
            aria-label="вернуться на главную страницу"
          >
            На Главную
          </button>
        </Link>
      </div>

    </>
  );
}

const Zoom = ({ zoomColor }) => {
  return <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 21L16.657 16.657M16.657 16.657C17.3998 15.9141 17.9891 15.0321 18.3912 14.0615C18.7932 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.94936 18.7932 8.90905 18.3912 7.93842C17.9891 6.96779 17.3998 6.08585 16.657 5.34296C15.9141 4.60007 15.0321 4.01078 14.0615 3.60874C13.0909 3.20669 12.0506 2.99976 11 2.99976C9.94936 2.99976 8.90905 3.20669 7.93842 3.60874C6.96779 4.01078 6.08585 4.60007 5.34296 5.34296C3.84263 6.84329 2.99976 8.87818 2.99976 11C2.99976 13.1217 3.84263 15.1566 5.34296 16.657C6.84329 18.1573 8.87818 19.0002 11 19.0002C13.1217 19.0002 15.1566 18.1573 16.657 16.657ZM11 7.99996V14M7.99996 11H14" stroke={zoomColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

}

export const ZoomImageContainer = ({ image }) => {
  const { openImagePopup } = useContext(PopupContext)
  return <div
    style={{ maxWidth: "650px", marginBottom: "20px" }}
    className="parameters__image-container"
  >
    <img
      className="col"
      alt="главная страница сайта "
      src={image}
      style={{ width: "100%" }}
    />
    <button
      className="parameters__zoom-button link"
      onClick={() => {

        openImagePopup({ image: image, height: '100%' })
      }
      }
    >
      <Zoom style={{ width: '100%' }} zoomColor={'white'} />
    </button>
  </div>
}

export default Parameters;
